import { useEffect } from 'react';

/**
 * Houdt een scrollend vak onderaan zodra `trigger` verandert — voor een
 * gesprek dat onderaan groeit. Nodig omdat ScrollToBottom alleen het hele
 * venster scrollt, en alleen bij het laden.
 *
 * @param {React.RefObject<HTMLElement>} ref - Het vak met overflow
 * @param {unknown} trigger - Verandert zodra er iets bijkomt (bijv. het aantal berichten)
 */
const useScrollToBottom = (ref, trigger) => {
    useEffect(() => {
        const el = ref.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [ref, trigger]);
};

export default useScrollToBottom;
